import React from "react";
import data from "../../../static/data/data.json";
import BestOfCube from "../../BestOfCube/BestOfCube";
import "./BestOf.scss";
import { useContext, useRef } from "react";
import { AppContext } from "../../../stores/application.store";
import { useEffect } from "react";
import smoothscroll from "smoothscroll-polyfill";
import { SendVote } from "../../../services/api";
import { ga_push } from "../../../services/analytics";
import { Environment } from "../../../services/urls";
import ReCAPTCHA from "react-google-recaptcha";
const BestOf = () => {
  const {
    setPageView,
    didFill,
    bestSinger,
    bestSongs,
    bestArtists,
    pageView,
  } = useContext(AppContext);
  const btnRef = useRef();
  const recaptchaRef = useRef();
  const Submit = async (token) => {


    if (!didFill.bestSongs) {
      alert("נדרש לבחור לפחות חמישה שירים");
      return;
    }
    if (!didFill.bestArtists) {
      alert("נדרש לבחור שלושה אמנים");
      return;
    }

    if (!didFill.bestSinger) {
      alert("נדרש לבחור את השיר הגרוע שלכם");
      return;
    }
    ga_push("navigation_events", "Navigation", "Finish Voting");

    data.Songs.filter((song) => bestSongs.includes(song.ID))
      .map((song) => song.SongName)
      .forEach((songName) =>
        ga_push("voting_events", "Vote", "Best song", songName)
      );

    data.Artists.filter((artist) => bestArtists.includes(artist.ID))
      .map((artist) => artist.Name)
      .forEach((artistName) => {
        ga_push("voting_events", "Vote", "Artist", artistName);
      });
    ga_push(
      "voting_events",
      "Vote",
      "Worst song",
      data.BestOf.find((best) => best.ID == bestSinger[0]).Name
    );

    SendVote({
      SingerVotes: bestArtists,
      SongVotes: bestSongs,
      WorstOfVote: bestSinger[0],
    }, token);
    window.dataLayer.push({
      event: "virtualPageview",
      virtualPageURL: "/glgltz-international/Thank-You",
      virtualPageTitle: "המצעד הבינלאומי השנתי - תודה על ההצבעה",
    });
    setPageView(4);
  };

  useEffect(() => {
    smoothscroll.polyfill();
  }, []);

  useEffect(() => {
    if (
      didFill.bestSinger &&
      didFill.bestSongs &&
      didFill.bestArtists &&
      pageView != 1
    ) {
      btnRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });


      btnRef.current.classList.add("wiggle");
      setTimeout(() => {
        btnRef.current.classList.remove("wiggle");
      }, 1000);
    }
  }, [didFill]);

  return (
    <div>
      <div className="best-of-text">
        <span>בחרו מהרשימה את</span>
        &nbsp;
        <span className="purple">השיר הגרוע של השנה</span>
      </div>
      <div className="best-of-page">
        {data.BestOf.map((artist) => {
          return <BestOfCube artist={artist} key={artist.ID} />;
        })}
        <div className="finished-button-container">
          <button
            ref={btnRef}
            className={`finished-button ${didFill.bestSinger && didFill.bestArtists && didFill.bestSongs
                ? "enabled"
                : ""
              }`}
            onClick={() => recaptchaRef.current.execute()}
          >
            סיימתי להצביע
          </button>

          <ReCAPTCHA
            onChange={Submit}
            sitekey="6LfoC3kUAAAAAPt8XZMzr6ljG2omdMJY7z8PPhpU"
            size="invisible"
            ref={recaptchaRef}
          />
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default BestOf;
